export const BrFlagAtom = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="28" fill="none">
      <g id="Group">
        <path
          id="Vector"
          d="M39.688 27.28H.312A.312.312 0 0 1 0 26.968V1.034C0 .86.14.72.313.72h39.374c.173 0 .313.14.313.313v25.934c0 .172-.14.312-.313.312Z"
          fill="#4BA543"
        />
        <path
          id="Vector_2"
          d="M37.586.721v26.56h2.102c.172 0 .313-.14.313-.313V1.034a.313.313 0 0 0-.313-.313h-2.102Z"
          fill="#43A047"
        />
        <path
          id="Vector_3"
          d="M5.478 13.747 19.821 3.746a.312.312 0 0 1 .358 0l14.343 10.001a.313.313 0 0 1 0 .513L20.179 24.261a.312.312 0 0 1-.358 0L5.478 14.26a.313.313 0 0 1 0-.513Z"
          fill="#FECE3F"
        />
        <path
          id="Vector_4"
          d="M20 19.793a5.795 5.795 0 1 0 0-11.59 5.795 5.795 0 0 0 0 11.59Z"
          fill="#2387EB"
        />
        <path
          id="Vector_5"
          d="M20 8.203c-.414 0-.818.045-1.207.127a5.796 5.796 0 0 1 0 11.336A5.795 5.795 0 1 0 20 8.203Z"
          fill="#207BD6"
        />
        <path
          id="Vector_6"
          d="m14.306 12.925 11.191 2.906a5.785 5.785 0 0 0 .268-2.425l-10.511-2.73a5.761 5.761 0 0 0-.948 2.249Z"
          fill="#EFEFEF"
        />
        <path
          id="Vector_7"
          d="m23.245 15.25 2.252.585a5.785 5.785 0 0 0 .268-2.425l-2.52-.655a5.811 5.811 0 0 1 0 2.495Z"
          fill="#DCDCDC"
        />
      </g>
    </svg>
  )
}
